import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import reducerData from '../reducers/data';
import reducerStatistics from '../reducers/stats';

const rootReducer = combineReducers({
  data: reducerData,
  stats: reducerStatistics,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(thunk),
  ),
);

export default store;
